import { Toggle, typographyRem } from '@by-miles/bymiles-styles'
import { DataLayer } from '@by-miles/data-layer'
import React, { useContext, useState } from 'react'

import { updateQuoteMutation } from '../../hooks/updateQuote'
import { useQuote } from '../../hooks/useQuote'
import { ProviderContext } from '../../Provider'
import { MarketingTogglesStyle } from './MarketingTogglesStyle'
const { h5: H5 } = typographyRem

export type MarketingProps = {
  post: boolean
  email: boolean
  phone: boolean
}

interface MarketingTogglesProps {
  borderColor?: 'darkAubergine' | 'aubergine'
  className?: string
  section: string
  onChange?: (value: MarketingProps) => void
}

export const MarketingToggles = ({
  borderColor = 'darkAubergine',
  className,
  section,
  onChange,
}: MarketingTogglesProps) => {
  const quote = useQuote()
  const { updateQuote } = updateQuoteMutation()

  const [marketing, setMarketing] = useState<MarketingProps>({
    email: quote?.details?.proposer?.marketing?.email || false,
    post: quote?.details?.proposer?.marketing?.post || false,
    phone: quote?.details?.proposer?.marketing?.phone || false,
  })

  const {
    state: { quoteId, showModal },
  } = useContext(ProviderContext)

  const tabFocusTrap = showModal ? -1 : 0

  const setMarketingPreferences = (key: string, value: boolean) => {
    DataLayer.customEvent({
      eventName: `${key} marketing ${value ? 'yes' : 'no'}`,
      section,
      eventType: 'form tracking',
    })
    const updatedMarketing = {
      ...marketing,
      [key]: value,
    }
    setMarketing(updatedMarketing)

    if (onChange) {
      onChange(updatedMarketing)
    } else {
      updateQuote({
        variables: {
          id: quoteId as string,
          actions: [{ setMarketingPreferences: { ...updatedMarketing } }],
        },
      })
    }
  }

  return (
    <MarketingTogglesStyle borderColor={borderColor} className={className}>
      <div className="toggle">
        <H5 className="LoNotSensitive">Email</H5>
        <Toggle
          defaultValue={marketing.email}
          onChange={(active: boolean) => setMarketingPreferences('email', active)}
          dataCy="marketing-email-toggle"
          tabFocusTrap={tabFocusTrap}
        />
      </div>
      <div className="toggle">
        <H5 className="LoNotSensitive">Post</H5>
        <Toggle
          defaultValue={marketing.post}
          onChange={(active: boolean) => setMarketingPreferences('post', active)}
          dataCy="marketing-post-toggle"
          tabFocusTrap={tabFocusTrap}
        />
      </div>
      <div className="toggle">
        <H5 className="LoNotSensitive">Phone</H5>
        <Toggle
          defaultValue={marketing.phone}
          onChange={(active: boolean) => setMarketingPreferences('phone', active)}
          dataCy="marketing-phone-toggle"
          tabFocusTrap={tabFocusTrap}
        />
      </div>
    </MarketingTogglesStyle>
  )
}
